import { Toggle as BaseToggle } from "@base-ui-components/react/toggle";
import { ToggleGroup as BaseGroup } from "@base-ui-components/react/toggle-group";
import { classed } from "@frend-digital/ui";

import styles from "./ToggleGroup.module.css";

export const ToggleGroup = classed(BaseGroup, styles.root);
export const Toggle = classed(BaseToggle, styles.toggle, {
	variants: {
		circular: {
			true: styles.circular,
		},
		inactive: {
			true: styles.inactive,
		},
	},
});
